import { TAG } from "../constants";
import {
  PatientPreferredPharmacy,
  PatientPreferredPharmacyCreate,
} from "../types";
import { patientApi } from "./patientApi";

export const preferredPharmacyApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    addPreferredPharmacy: builder.mutation<
      PatientPreferredPharmacy,
      Omit<PatientPreferredPharmacyCreate, "patient_id">
    >({
      query: (body) => ({
        method: "POST",
        url: `/api/patient/patient-preferred-pharmacies`,
        body,
      }),
      invalidatesTags: (_res, _error, args) => [
        {
          type: TAG.PREFERRED_PHARMACY,
          id: args.id,
        },
      ],
    }),
    getPatientPreferredPharmacy: builder.query<PatientPreferredPharmacy, void>({
      query: () => ({
        method: "GET",
        url: `/api/patient/patient-preferred-pharmacies`,
      }),
      providesTags: [TAG.PREFERRED_PHARMACY],
    }),
  }),
});

export const {
  useAddPreferredPharmacyMutation,
  useGetPatientPreferredPharmacyQuery,
} = preferredPharmacyApi;
